<template>
  <main class="c13 doc-container">
    <p class="c9 c7"><span class="c4"></span></p><a id="id.gjdgxs"></a>
    <p class="c6"><span class="c1">POL&Iacute;TICA DE PRIVACIDADE E PROTE&Ccedil;&Atilde;O DE DADOS PESSOAIS</span></p>
    <p class="c9"><span class="c20">Data de publica&ccedil;&atilde;o: 22/09/2021</span></p>
    <p class="c9 c7"><span class="c1"></span></p>
    <p class="c6"><span class="c1">Pre&acirc;mbulo</span></p>
    <p class="c7 c9"><span class="c1"></span></p>
    <p class="c0"><span class="c1">A pol&iacute;tica de Prote&ccedil;&atilde;o de Dados Pessoais da &nbsp;JUSTTO
        INOVA&Ccedil;&Otilde;ES TECNOL&Oacute;GICAS PARA RESOLU&Ccedil;&Atilde;O DE CONFLITOS S.A. (&ldquo;JUSTTO)
      </span><span class="c4">foi elaborado em conformidade com a Lei Geral de </span><span class="c5">Prote&ccedil;&atilde;o</span><span class="c4">&nbsp;de Dados Pessoais &ndash; LGPD (Lei federal n&ordm;
        13.709/2018) e vincula todos os funcion&aacute;rios, </span><span class="c5">administradores,</span><span class="c4">&nbsp;colaboradores e </span><span class="c5">parceiros</span><span class="c4">&nbsp;da </span><span class="c1">&nbsp;JUSTTO</span><span class="c4">, sobre o tratamento de dados pessoais decorrentes da sua atividade
        comercial.</span></p>
    <p class="c9 c7"><span class="c4"></span></p>
    <p class="c0 c12"><span class="c4">Esta Pol&iacute;tica de Prote&ccedil;&atilde;o de Dados Pessoais cont&eacute;m
        informa&ccedil;&otilde;es a respeito do modo como a </span><span class="c1">JUSTTO </span><span class="c4">trata,
        total ou parcialmente, de forma automatizada ou n&atilde;o, os dados pessoais decorrentes das atividades previstas
        no par&aacute;grafo anterior.</span></p>
    <p class="c0 c7 c12"><span class="c4"></span></p>
    <p class="c0 c12"><span class="c4">O objetivo &eacute; esclarecer os titulares dos dados pessoais acerca dos tipos de
        dados que s&atilde;o tratados, as suas hip&oacute;teses e finalidades </span><span class="c5">e a
        forma</span><span class="c4">&nbsp;como o titular destes dados poder&aacute; atualizar, gerenciar ou excluir estas
        informa&ccedil;&otilde;es, bem como exercer os seus direitos previstos na LGPD. </span></p>
    <p class="c0 c7 c12"><span class="c4"></span></p>
    <p class="c0 c12"><span class="c4">Ao utilizar os nossos servi&ccedil;os, trabalhar conosco ou se candidatar a uma
        vaga de trabalho, o titular dos dados pessoais aceita e concorda com todos os termos e condi&ccedil;&otilde;es
        expostos que se encontram vigentes na data.</span></p>
    <p class="c0 c7 c12"><span class="c4"></span></p>
    <p class="c0 c12"><span class="c4">Alertamos que esta Pol&iacute;tica de Prote&ccedil;&atilde;o de Dados Pessoais
        poder&aacute; ser modificada a qualquer momento pela </span><span class="c1">JUSTTO</span><span class="c4">, em
        virtude de altera&ccedil;&otilde;es na legisla&ccedil;&atilde;o ou em nossos processos, em decorr&ecirc;ncia da
        utiliza&ccedil;&atilde;o de novas ferramentas tecnol&oacute;gicas ou, ainda, sempre que, a exclusivo
        crit&eacute;rio da </span><span class="c1">JUSTTO</span><span class="c4">, tais altera&ccedil;&otilde;es se
        fa&ccedil;am necess&aacute;rias.</span></p>
    <p class="c9 c7"><span class="c4"></span></p>
    <p class="c6 c17"><span class="c1">Princ&iacute;pios e Direitos do Titular de Dados Pessoais</span></p>
    <p class="c9 c7"><span class="c1"></span></p>
    <p class="c0"><span class="c1">Artigo 1&ordm;. </span><span class="c4">A </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se compromete a cumprir as normas previstas na LGPD, em respeito aos seguintes
        princ&iacute;pios:</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">I</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        tratados de forma l&iacute;cita, leal e transparente; </span></p>
    <p class="c0"><span class="c1">II</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        tratados apenas para finalidades determinadas, expl&iacute;citas e leg&iacute;timas, n&atilde;o podendo ser
        tratados posteriormente de uma forma incompat&iacute;vel com essas finalidades; </span></p>
    <p class="c0"><span class="c1">III</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        coletados de forma adequada, pertinente e limitada ao atendimento das finalidades para as quais eles ser&atilde;o
        tratados; </span></p>
    <p class="c0"><span class="c1">IV</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        exatos e atualizados sempre que necess&aacute;rio, de maneira que os dados inexatos sejam descartados ou
        retificados, quando poss&iacute;vel; </span></p>
    <p class="c0"><span class="c1">V</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        conservados de uma forma que permita a identifica&ccedil;&atilde;o dos titulares dos dados apenas durante o
        per&iacute;odo necess&aacute;rio para as finalidades para as quais s&atilde;o tratados; </span></p>
    <p class="c0"><span class="c1">VI</span><span class="c4">&nbsp;&ndash; Os dados pessoais do titular ser&atilde;o
        tratados de forma segura, protegidos do tratamento n&atilde;o autorizado ou il&iacute;cito e contra a sua perda,
        destrui&ccedil;&atilde;o ou danifica&ccedil;&atilde;o acidental, adotando as medidas t&eacute;cnicas ou
        organizativas adequadas. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 2&ordm;. </span><span class="c4">O titular possui os seguintes direitos,
        conferidos pela LGPD:</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">I</span><span class="c4">&nbsp;&ndash; Direito de confirma&ccedil;&atilde;o e acesso:
        &eacute; o direito do titular de obter a confirma&ccedil;&atilde;o de que os dados pessoais que lhe digam respeito
        s&atilde;o ou n&atilde;o objeto de tratamento e, se for esse o caso, o direito de acessar os seus dados
        pessoais;</span></p>
    <p class="c0"><span class="c1">II</span><span class="c4">&nbsp;&ndash; Direito de retifica&ccedil;&atilde;o: &eacute;
        o direito do titular de obter, sem demora injustificada, a retifica&ccedil;&atilde;o dos dados pessoais inexatos
        que lhe digam respeito;</span></p>
    <p class="c0"><span class="c1">III</span><span class="c4">&nbsp;&ndash; Direito &agrave; elimina&ccedil;&atilde;o dos
        dados: &eacute; o direito do titular de ter seus dados apagados dos sistemas ou do banco de dados da plataforma da
      </span><span class="c1">JUSTTO</span><span class="c4">;</span></p>
    <p class="c0"><span class="c1">IV</span><span class="c4">&nbsp;&ndash; Direito &agrave; limita&ccedil;&atilde;o do
        tratamento dos dados: &eacute; o direito do titular de limitar o tratamento de seus dados pessoais, podendo
        obt&ecirc;-la quando contesta a exatid&atilde;o dos dados, quando o tratamento for il&iacute;cito, quando a
      </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;n&atilde;o precisar mais dos dados para as finalidades
        propostas e quando tiver se oposto ao tratamento dos dados e em caso de tratamento de dados
        desnecess&aacute;rios;</span></p>
    <p class="c0"><span class="c1">V</span><span class="c4">&nbsp;&ndash; Direito de oposi&ccedil;&atilde;o: &eacute; o
        direito do titular de, a qualquer momento, se opor por motivos relacionados com a sua situa&ccedil;&atilde;o
        particular, ao tratamento dos dados pessoais que lhe digam respeito, podendo se opor ainda ao uso de seus dados
        pessoais para defini&ccedil;&atilde;o de perfil de marketing;</span></p>
    <p class="c0"><span class="c1">VI</span><span class="c4">&nbsp;&ndash; Direito de portabilidade dos dados: &eacute; o
        direito do titular de receber os dados pessoais que lhe digam respeito e que tenha fornecido ao sistema ou na
        plataforma da </span><span class="c1">JUSTTO</span><span class="c4">, num formato estruturado, de uso corrente e
        de leitura autom&aacute;tica, e o direito de transmitir esses dados a outro aplicativo;</span></p>
    <p class="c9 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 3&ordm;. </span><span class="c4">O titular poder&aacute; exercer os seus
        direitos por meio de comunica&ccedil;&atilde;o escrita enviada por e-mail com o assunto &ldquo;tratamento de dados
        pessoais&ldquo;, especificando: </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <ol
      class="c15 lst-kix_list_1-0 start"
      start="1"
    >
      <li class="c0 c2 li-bullet-0"><span class="c4">Nome completo; </span></li>
      <li class="c0 c2 li-bullet-0"><span class="c4">N&uacute;mero do CPF; </span></li>
      <li class="c0 c2 li-bullet-0"><span class="c4">Endere&ccedil;o de e-mail do titular e, se for o caso, do seu
          representante;</span></li>
      <li class="c0 c2 li-bullet-0"><span class="c4">Direito que deseja exercer junto ao sistema;</span></li>
      <li class="c0 c2 li-bullet-0"><span class="c4">Data do pedido e assinatura do titular; e</span></li>
      <li class="c0 c2 li-bullet-0"><span class="c4">Todo documento que possa demonstrar ou justificar o exerc&iacute;cio
          de seu direito.</span></li>
    </ol>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 4&ordm;. </span><span class="c4">O pedido dever&aacute; ser enviado ao e-mail:
      </span><span class="c16 c5 c23"><a
          class="c14"
          href="mailto:contato@justto.com.br"
        >contato@justto.com.br</a></span><span class="c4">, ou por correio, ao
        seguinte endere&ccedil;o:</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c4">Av. Paulista, 171, 4&ordf; andar</span></p>
    <p class="c0"><span class="c4">Bela Vista, CEP 01311-000</span></p>
    <p class="c0"><span class="c4">S&atilde;o Paulo - SP</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 5&ordm;. </span><span class="c4">Todos os pedidos ser&atilde;o recebidos,
        analisados e se necess&aacute;rio ser&atilde;o encaminhados para o controlador respons&aacute;vel pelos dados
        tratados (geralmente, um cliente da </span><span class="c1">JUSTTO</span><span class="c4">) que dever&aacute;
        responder, em uma prazo de at&eacute; 15 dias, contados da confirma&ccedil;&atilde;o de autenticidade de quem
        formulou o pedido e o correspondente titular dos dados pessoais sobre os quais se pretende exercer o respectivo
        direito. </span></p>
    <p class="c6 c7"><span class="c22"></span></p>
    <p class="c6"><span class="c1">Dados Pessoais Tratados </span></p>
    <p class="c0 c7"><span class="c1"></span></p>
    <p class="c0 c8"><span class="c1">Artigo 6&ordm;. </span><span class="c4">O tratamento de dados pessoais pela
      </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;ocorrer&aacute; em conformidade com a LGPD, sendo que os
        dados tratados incluem:</span></p>
    <p class="c0 c7 c8"><span class="c4"></span></p>
    <p class="c0 c8"><span class="c1">I</span><span class="c4">&nbsp;&ndash; Dados pessoais individuais
        como:&nbsp;documentos e n&uacute;meros de identifica&ccedil;&atilde;o;&nbsp;nome completo; endere&ccedil;o de
        correio eletr&ocirc;nico; contatos; endere&ccedil;o postal residencial; n&uacute;meros de telefone; data de
        nascimento; nacionalidade e naturalidade;</span></p>
    <p class="c0 c8"><span class="c1">II</span><span class="c4">&nbsp;&ndash; &nbsp;Dados financeiros como: dados
        banc&aacute;rios tais como nome o banco n&uacute;mero de conta, </span><span class="c5">n&uacute;mero</span><span class="c4">&nbsp;da ag&ecirc;ncia, chaves PIX;</span></p>
    <p class="c0"><span class="c3">III</span><span class="c4">&nbsp;&ndash; Dados de lit&iacute;gios como: n&uacute;mero
        de processos adminstrativos e/ou judiciais;&nbsp;objeto dos respectivos processos; valor do pedido e de eventual
        condena&ccedil;&atilde;o sofrida em processos administrativos ou judiciais;</span></p>
    <p class="c0"><span class="c3">IV</span><span class="c4">&nbsp;&ndash; Prefer&ecirc;ncias e comportamentos
        relacionados ao uso de nossos servi&ccedil;os;</span></p>
    <p class="c0"><span class="c3">V</span><span class="c4">&nbsp;&ndash; Informa&ccedil;&otilde;es sobre sistema
        operacional e navegador do dispositivo;</span></p>
    <p class="c0"><span class="c3">VI</span><span class="c4">&nbsp;&ndash; Endere&ccedil;o IP;</span></p>
    <p class="c0"><span class="c3">VII</span><span class="c4">&nbsp;&ndash; Funcionalidades acessadas e as
        intera&ccedil;&otilde;es realizadas.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 7&ordm;.</span><span class="c4">&nbsp;Eventualmente, outros tipos de dados
        n&atilde;o previstos expressamente nesta Pol&iacute;tica de Privacidade e Prote&ccedil;&atilde;o de Dados
        poder&atilde;o ser tratados pela JUSTTO, desde que o seu tratamento esteja contemplado dentre as hip&oacute;teses
        previstas na LGPD. </span></p>
    <p class="c9 c7 c24"><span class="c1"></span></p>
    <p class="c6"><span class="c1">Origem dos Dados Pessoais Tratados</span></p>
    <p class="c0 c7 c8"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 8&ordm;. </span><span class="c5">Os dados pessoais tratados pela </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;s&atilde;o originalmente informados pelos clientes seus clientes,
        que os cadastram na plataforma administrada pela </span><span class="c3">JUSTTO</span><span class="c4">, os quais
        s&atilde;o obtidos por meio dos dados e informa&ccedil;&otilde;es constantes nos autos dos pr&oacute;prios
        processos onde os clientes atuar&atilde;o, seja na defesa de seus pr&oacute;prios interesses ou daqueles que
        representam judicialmente. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Par&aacute;grafo &uacute;nico. </span><span class="c5">Quando os dados constantes no
        processo ainda s&atilde;o insuficientes para entrar em contato com a parte contr&aacute;ria, ou com seu
        procurador, para celebra&ccedil;&atilde;o de eventual acordo, mediante solicita&ccedil;&atilde;o expressa do
        cliente, a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;realiza o enriquecimento dos dados
        disponibilizados nos tribunais, por meio de bureaus de informa&ccedil;&otilde;es p&uacute;blicas e tamb&eacute;m
        se vale de sub operadores (Nova Vida, Assertiva e BipBop), que auxiliam na manuten&ccedil;&atilde;o da qualidade
        dos dados pessoais que s&atilde;o tratados, alimentando assim sua base de dados referente ao caso
        espec&iacute;fico. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Agentes de Tratamento de Dados Pessoais</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 9&ordm;.</span><span class="c5">&nbsp;A </span><span class="c3">JUSTTO</span><span class="c5">, enquanto agente de tratamento de dados pessoais, poder&aacute; atuar
        como Controlador Independente, Operador ou Controlador a depender do tipo de tratamento que ser&aacute; realizado
        pela </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;com os dados pessoais, conforme discriminado
        abaixo. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 10&ordm;. </span><span class="c5">Nas situa&ccedil;&otilde;es em que a
      </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;prestar o servi&ccedil;os de licenciamento de software
        (SaaS) para seus clientes, disponibilizando a sua plataforma para realiza&ccedil;&atilde;o de acordos ou
        comunica&ccedil;&otilde;es com terceiros, a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na qualidade de Operador, estando os seus clientes na qualidade de Controladores
        dos respectivos dados pessoais. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 11&ordm;.</span><span class="c5">&nbsp;Quando a </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;realizar o servi&ccedil;o de enriquecimento de dados pessoais, para
        apoiar e promover atividades de interesse e em benef&iacute;cio do pr&oacute;prio titular, a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na qualidade de Controlador Independente, tendo em
        vista a discricionariedade que ostenta na presta&ccedil;&atilde;o deste servi&ccedil;o.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 12&ordm;.</span><span class="c5">&nbsp;Nas rela&ccedil;&otilde;es da
      </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;com seus clientes, colaboradores e funcion&aacute;rios,
        que resultar no tratamento de dados pessoais, a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na qualidade de Controlador destes dados, o poder de decis&atilde;o pr&oacute;prio
        que possui com rela&ccedil;&atilde;o &agrave; integralidade do tratamento destes dados pessoais. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Hip&oacute;teses de Tratamento e Finalidades</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 13&ordm;.</span><span class="c5">&nbsp;O tratamento de dados pessoais inseridos
        no banco de dados da </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;por seus clientes, bem como dados
        pessoais obtidos de forma independente pela </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;e dados
        derivados do cruzamento e enriquecimento dos dados referidos anteriormente ser&aacute; realizado em
        observ&acirc;ncia &agrave;s hip&oacute;teses previstas na LGPD, com o objetivo de atender &agrave;s seguintes
        finalidades: </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">I </span><span class="c5">&ndash; Para exerc&iacute;cio regular de direitos em processo
        judicial, administrativo ou arbitral: dados pessoais ser&atilde;o utilizados para esta finalidade quando da
        presta&ccedil;&atilde;o do servi&ccedil;o discriminado no Artigo 10&ordm; desta Pol&iacute;tica,
        situa&ccedil;&atilde;o na qual a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na
        qualidade de Operador; </span></p>
    <p class="c0"><span class="c3">II </span><span class="c5">&ndash; Leg&iacute;timo interesse da </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;ou de terceiro: dados pessoais ser&atilde;o utilizados para esta
        finalidade quando da presta&ccedil;&atilde;o do servi&ccedil;o discriminado no Artigo 11&ordm; desta
        Pol&iacute;tica, n&atilde;o afetando direitos e liberdades fundamentais dos titulares, situa&ccedil;&atilde;o na
        qual a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; como Controlador Independente;
      </span></p>
    <p class="c0"><span class="c3">III</span><span class="c5">&nbsp;&ndash; Cumprimento de obriga&ccedil;&atilde;o legal
        ou regulat&oacute;ria: dados pessoais decorrentes da rela&ccedil;&atilde;o entre a </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;e seus funcion&aacute;rios, colaboradores e clientes, conforme
        discriminado no Artigo 12&ordm; desta Pol&iacute;tica, situa&ccedil;&atilde;o na qual a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na qualidade de Controlador; e </span></p>
    <p class="c0"><span class="c3">IV</span><span class="c5">&nbsp;&ndash; Execu&ccedil;&atilde;o de contrato ou
        procedimentos preliminares relacionados: dados pessoais decorrentes da rela&ccedil;&atilde;o entre a </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;e seus funcion&aacute;rios, colaboradores e clientes, conforme
        discriminado no Artigo 12&ordm; desta Pol&iacute;tica, situa&ccedil;&atilde;o na qual a </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;atuar&aacute; na qualidade de Controlador. &nbsp;</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Armazenamento e Per&iacute;odo de Conserva&ccedil;&atilde;o dos Dados Pessoais</span>
    </p>
    <p class="c6 c7"><span class="c1"></span></p>
    <p class="c0"><span class="c3">Artigo 14&ordm;. </span><span class="c5">Os dados pessoais s&atilde;o armazenados em
        ambiente seguro e controlado e podem ser armazenados em nossos servidores pr&oacute;prios ou de terceiros
        contratados para esse fim (sub operadores), sejam eles alocados &nbsp;Brasil ou &nbsp;no exterior, de acordo com
        os crit&eacute;rios a legisla&ccedil;&atilde;o aplic&aacute;vel, podendo ainda serem armazenados por meio de
        tecnologia de </span><span class="c5 c19">cloud computing</span><span class="c4">&nbsp;e/ou outras que surjam
        futuramente, visando sempre a sua melhoria e aperfei&ccedil;oamento. &nbsp;</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 15&ordm;. </span><span class="c5">Os dados pessoais tratados pela </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;ser&atilde;o conservados por um per&iacute;odo n&atilde;o superior
        ao exigido para cumprir e se atingir as finalidades para as quais eles foram inicialmente tratados, conforme
        discriminado nesta Pol&iacute;tica. &nbsp;</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Par&aacute;grafo &uacute;nico.</span><span class="c5">&nbsp;Os dados pessoais dos
        titulares apenas poder&atilde;o ser conservados ap&oacute;s o t&eacute;rmino de seu tratamento, para (i)
        cumprimento de obriga&ccedil;&atilde;o legal ou regulat&oacute;ria pela </span><span class="c3">JUSTTO</span><span class="c4">; e/ou (ii) exerc&iacute;cio regular de direitos em processo judicial ou administrativo, sendo que, em
        ambas hip&oacute;teses, referido per&iacute;odo n&atilde;o ultrapassar&aacute; o prazo de 5 (cinco) anos.</span>
    </p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 16&ordm;.</span><span class="c5">&nbsp;Nas situa&ccedil;&otilde;es em que a
      </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;atuar na qualidade de Operador, a
        conserva&ccedil;&atilde;o dos dados pessoais estar&aacute; condicionado &agrave;s orienta&ccedil;&otilde;es
        l&iacute;citas dos seus clientes (Controladores), as quais ser&atilde;o observadas pela </span><span class="c3">JUSTTO</span><span class="c4">, desde que compat&iacute;veis com os direitos e garantias previstas na
        LGPD. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Rela&ccedil;&atilde;o entre a JUSTTO e terceiros na transmiss&atilde;o de dados
        pessoais</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Artigo 17&ordm;.</span><span class="c5">&nbsp;Em determinadas circunst&acirc;ncias, a
      </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;poder&aacute; compartilhar ou transferir dados pessoais,
        na estrita medida necess&aacute;ria ou apropriada, para &oacute;rg&atilde;os governamentais, parceiros de
        neg&oacute;cios e outros com o objetivo de cumprir a legisla&ccedil;&atilde;o aplic&aacute;vel, ordem ou
        intima&ccedil;&atilde;o judicial, ou, ainda, para: </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">I</span><span class="c4">&nbsp;&ndash; Prestar os servi&ccedil;os discriminados no
        Artigo 11&ordm; desta Pol&iacute;tica;</span></p>
    <p class="c0"><span class="c3">II</span><span class="c4">&nbsp;&ndash; Investigar, impedir ou tomar medidas
        relacionadas a atividades ilegais suspeitas ou reais, ou para cooperar com &oacute;rg&atilde;os p&uacute;blicos,
        ou para proteger a seguran&ccedil;a nacional; </span></p>
    <p class="c0"><span class="c3">III</span><span class="c4">&nbsp;&ndash; Execu&ccedil;&atilde;o de seus contratos;
      </span></p>
    <p class="c0"><span class="c3">IV</span><span class="c4">&nbsp;&ndash; Investigar e se defender contra quaisquer
        reivindica&ccedil;&otilde;es ou alega&ccedil;&otilde;es de terceiros; </span></p>
    <p class="c0"><span class="c3">V</span><span class="c4">&nbsp;&ndash; Proteger os direitos e a seguran&ccedil;a
        pessoal do titular dos dados pessoais, de seus funcion&aacute;rios, colaboradores internos, clientes ou do
        p&uacute;blico em geral; </span></p>
    <p class="c0"><span class="c3">VI </span><span class="c5">&ndash; Exercer ou proteger os direitos, a propriedade e a
        seguran&ccedil;a da </span><span class="c3">JUSTTO</span><span class="c4">&nbsp;e de seus acionistas; </span></p>
    <p class="c0"><span class="c3">VII</span><span class="c5">&nbsp;&ndash; Em caso de venda, compra, fus&atilde;o,
        reorganiza&ccedil;&atilde;o, liquida&ccedil;&atilde;o ou dissolu&ccedil;&atilde;o da </span><span class="c3">JUSTTO</span><span class="c4">. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c3">Par&aacute;grafo &uacute;nico.</span><span class="c4">&nbsp;Todas as
        situa&ccedil;&otilde;es de compartilhamento e transmiss&atilde;o de dados pessoais para terceiros, caso n&atilde;o
        esteja prevista nesta Pol&iacute;tica de Privacidade e Prote&ccedil;&atilde;o de Dados Pessoais, ser&atilde;o
        informadas previamente ao respectivo titular dos dados pessoais, que, nas hip&oacute;teses previstas na LGPD,
        poder&aacute; se opor a esse compartilhamento e transmiss&atilde;o.</span></p>
    <p class="c6 c7"><span class="c1"></span></p>
    <p class="c6 c10"><span class="c1">Encarregado de Prote&ccedil;&atilde;o de Dados</span></p>
    <p class="c9 c10 c7"><span class="c4"></span></p>
    <p class="c0 c10"><span class="c3">Artigo 18&ordm;.</span><span class="c5">&nbsp;O Encarregado de
        Prote&ccedil;&atilde;o de Dados &eacute; o profissional indicado e nomeado pela </span><span class="c3">JUSTTO</span><span class="c4">, para atuar como canal de comunica&ccedil;&atilde;o entre a JUSTTO, os
        titulares dos dados pessoais e a Autoridade Nacional de Prote&ccedil;&atilde;o de Dados (ANPD). </span></p>
    <p class="c0 c10 c7"><span class="c4"></span></p>
    <p class="c0 c10"><span class="c3">Par&aacute;grafo &uacute;nico.</span><span class="c5">&nbsp;O Encarregado de
        Prote&ccedil;&atilde;o de Dados da </span><span class="c3">JUSTTO</span><span class="c5">&nbsp;&eacute; o Sr.
        Deivid Celso Barbosa, que poder&aacute; ser contatado pelo e-mail </span><span class="c5 c16"><a
          class="c14"
          href="mailto:deivid@justto.com.br"
        >deivid@justto.com.br</a></span><span class="c4">&nbsp;ou no
        endere&ccedil;o:</span></p>
    <p class="c0 c10 c7"><span class="c4"></span></p>
    <p class="c0 c10"><span class="c4">Av. Paulista, 171, 4&ordm; andar, </span></p>
    <p class="c0 c10"><span class="c4">Bela Vista, S&atilde;o Paulo-SP</span></p>
    <p class="c0 c10"><span class="c4">CEP 01311-904</span></p>
    <p class="c0 c10 c7"><span class="c4"></span></p>
    <p class="c6 c10"><span class="c1">Seguran&ccedil;a no Tratamento dos Dados Pessoais </span></p>
    <p class="c9 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 19&ordm;. </span><span class="c4">A </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se compromete a aplicar controles para proteger os dados pessoais de acessos n&atilde;o
        autorizados e de situa&ccedil;&otilde;es de destrui&ccedil;&atilde;o, perda, altera&ccedil;&atilde;o,
        comunica&ccedil;&atilde;o ou divulga&ccedil;&atilde;o de tais dados.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Par&aacute;grafo &uacute;nico. </span><span class="c4">Para a garantia da
        seguran&ccedil;a, ser&atilde;o adotadas medidas t&eacute;cnidas e administrativas que levem em
        considera&ccedil;&atilde;o: as t&eacute;cnicas adequadas; os custos de aplica&ccedil;&atilde;o; a natureza, o
        &acirc;mbito, o contexto e as finalidades do tratamento; e os riscos para os direitos e liberdades do
        usu&aacute;rio. As formas como a </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;faz isso
        incluem:</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">I </span><span class="c5">- Uso</span><span class="c4">&nbsp;de criptografia ao coletar
        ou transferir informa&ccedil;&otilde;es. Os sistemas da </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;</span><span class="c5">utilizem</span><span class="c4">&nbsp;certificados SSL (Secure Socket
        Layer) que garantem que os dados pessoais se transmitam de forma segura e confidencial, de maneira que a
        transmiss&atilde;o dos dados entre o servidor e o usu&aacute;rio ocorra de maneira totalmente cifrada ou
        encriptada; </span></p>
    <p class="c0"><span class="c1">II </span><span class="c4">&ndash; Defini&ccedil;&atilde;o de prote&ccedil;&otilde;es
        de seguran&ccedil;a de dados da </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;para garantir a
        seguran&ccedil;a, integridade, disponibilidade e resili&ecirc;ncia cont&iacute;nuas dos sistemas e servi&ccedil;os
        de processamento; </span></p>
    <p class="c0"><span class="c1">III</span><span class="c4">&nbsp;&ndash; Limita&ccedil;&atilde;o do acesso
        f&iacute;sico &agrave;s instala&ccedil;&otilde;es da </span><span class="c1">JUSTTO</span><span class="c4">;</span></p>
    <p class="c0"><span class="c1">IV </span><span class="c4">&ndash; Limita&ccedil;&atilde;o do acesso &agrave;s
        informa&ccedil;&otilde;es que s&atilde;o tratadas pela </span><span class="c1">JUSTTO</span><span class="c4">;</span></p>
    <p class="c0"><span class="c1">V </span><span class="c4">&ndash; Verifica&ccedil;&atilde;o e monitoramento de que os
        parceiros de neg&oacute;cios da </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;tenham medidas de
        seguran&ccedil;a t&eacute;cnica e organizacional apropriadas para manter os respectivos dados pessoais protegidos;
      </span></p>
    <p class="c0"><span class="c1">VI</span><span class="c4">&nbsp;&ndash; </span><span class="c5">Pseudo
        Anonimiza&ccedil;&atilde;o</span><span class="c4">&nbsp;e/ou anonimiza&ccedil;&atilde;o de dados pessoais.</span>
    </p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 20&ordm;.</span><span class="c4">&nbsp;A </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se exime de responsabilidade por culpa exclusiva de terceiro, como
        em caso de ataque hacker, cracker, ou culpa exclusiva do titular dos dados pessoais. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 21&ordm;. </span><span class="c4">A </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se compromete a comunicar ao titular dos dados pessoais, em prazo adequado, caso ocorra algum
        tipo de viola&ccedil;&atilde;o da seguran&ccedil;a de seus dados pessoais que possa lhe causar um alto risco para
        seus direitos e liberdades individuais, utilizando os meios de comunica&ccedil;&atilde;o dispon&iacute;veis para
        contato, que podem ser telefone, endere&ccedil;o eletr&ocirc;nico ou comunica&ccedil;&atilde;o em suas plataformas
        digitais e m&iacute;dias sociais. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 22&ordm;.</span><span class="c4">&nbsp;Caso empresas terceiras realizem o
        tratamento de quaisquer dos dados pessoais decorrentes dos servi&ccedil;os prestados pela </span><span class="c1">JUSTTO</span><span class="c4">, estejam elas na qualidade de Operador ou </span><span class="c5">Sub
        Operador,</span><span class="c4">&nbsp;dever&atilde;o observar e respeitar as condi&ccedil;&otilde;es aqui
        estipuladas, bem como as normas de Seguran&ccedil;a da Informa&ccedil;&atilde;o da </span><span class="c1">JUSTTO</span><span class="c4">.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Dados de Navega&ccedil;&atilde;o (</span><span class="c3 c18">cookies</span><span class="c1">)</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 23&ordm;. </span><span class="c4">Quando qualquer usu&aacute;rio utilizar a
        plataforma da </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;ou acessar o seu website, a </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se valer&aacute; de </span><span class="c18 c5">cookies</span><span class="c4">&nbsp;(marcadores digitais que s&atilde;o automaticamente inseridos no dispositivo do usu&aacute;rio),
        para permitir a funcionalidade dos servi&ccedil;os prestados pela </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;e a sua navega&ccedil;&atilde;o neste ambiante digital.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Par&aacute;grafo Primeiro.</span><span class="c4">&nbsp;A </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;esclarece que utiliza apenas </span><span class="c18 c5">first-party cookies</span><span class="c4">&nbsp;e, dentre eles, apenas </span><span class="c18 c5">cookies</span><span class="c4">&nbsp;necess&aacute;rios para dar suporte &agrave;s ferramentas de
        autentica&ccedil;&atilde;o do usu&aacute;rio e permitir a continuidade das transa&ccedil;&otilde;es com os
        servidores.</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Par&aacute;grafo Segundo.</span><span class="c4">&nbsp;Demais informa&ccedil;&otilde;es
        relacionadas &agrave; configura&ccedil;&atilde;o e gerenciamento dos cookies podem ser acessados na
        Pol&iacute;tica de Cookies da </span><span class="c1">JUSTTO</span><span class="c4">. &nbsp;</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Reclama&ccedil;&atilde;o a uma Autoridade de Controle</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 24&ordm;.</span><span class="c4">&nbsp;Sem preju&iacute;zo de qualquer outra via
        de recurso administrativo ou judicial, todos os titulares de dados pessoais t&ecirc;m o direito de apresentar
        reclama&ccedil;&atilde;o a uma autoridade de controle. A reclama&ccedil;&atilde;o poder&aacute; ser feita &agrave;
        Autoridade Nacional de Prote&ccedil;&atilde;o de Dados (ANPD). </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Altera&ccedil;&otilde;es</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 25&ordm;.</span><span class="c4">&nbsp;A presente Pol&iacute;tica de Privacidade
        e Prote&ccedil;&atilde;o de Dados Pessoais poder&aacute; receber revis&otilde;es peri&oacute;dicas. Entretanto, a
      </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;se reserva </span><span class="c5">o direito</span><span class="c4">&nbsp;de modificar, a qualquer tempo, as presentes disposi&ccedil;&otilde;es, especialmente para
        adapt&aacute;-las &agrave;s evolu&ccedil;&otilde;es dos sistemas ou de seu programa de computador, seja pela
        disponibiliza&ccedil;&atilde;o de novas funcionalidades, seja pela supress&atilde;o ou modifica&ccedil;&atilde;o
        daquelas j&aacute; existentes. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Par&aacute;grafo &uacute;nico. </span><span class="c4">O titular dos dados pessoais
        sempre ser&aacute; notificado pela </span><span class="c1">JUSTTO</span><span class="c4">&nbsp;em caso de
        altera&ccedil;&atilde;o desta Pol&iacute;tica de Privacidade e Prote&ccedil;&atilde;o de Dados Pessoais. Caso
        discorde de alguma das modifica&ccedil;&otilde;es, dever&aacute; apresentar a sua ressalva ao Encarregado de
        Prote&ccedil;&atilde;o de Dados, se assim o desejar. </span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c6"><span class="c1">Legisla&ccedil;&atilde;o Aplic&aacute;vel e Foro</span></p>
    <p class="c0 c7"><span class="c4"></span></p>
    <p class="c0"><span class="c1">Artigo 26&ordm;. </span><span class="c4">Esta Pol&iacute;tica de Privacidade e
        Prote&ccedil;&atilde;o de Dados Pessoais e todas as rela&ccedil;&otilde;es dela decorrentes s&atilde;o submetidas
        &agrave;s leis da Rep&uacute;blica Federativa do Brasil, sendo eleito o foro da Comarca da Capital do Estado de
        S&atilde;o Paulo, para dirimir qualquer controv&eacute;rsia decorrente desta Pol&iacute;tica de Privacidade e
        Prote&ccedil;&atilde;o de Dados Pessoais.</span></p>
    <div>
      <p class="c7 c21"><span class="c11"></span></p>
    </div>
  </main>
</template>

<style type="text/css">
@import url("https://themes.googleusercontent.com/fonts/css?kit=-lTUqgJg2dxbe4D7B5DEIA3jn2WilaVUapNOYl4762s");

ol.lst-kix_list_1-3 {
  list-style-type: none;
}

ol.lst-kix_list_1-4 {
  list-style-type: none;
}

ol.lst-kix_list_1-5 {
  list-style-type: none;
}

ol.lst-kix_list_1-6 {
  list-style-type: none;
}

ol.lst-kix_list_1-0 {
  list-style-type: none;
}

.lst-kix_list_1-4 > li {
  counter-increment: lst-ctn-kix_list_1-4;
}

ol.lst-kix_list_1-1 {
  list-style-type: none;
}

ol.lst-kix_list_1-2 {
  list-style-type: none;
}

ol.lst-kix_list_1-6.start {
  counter-reset: lst-ctn-kix_list_1-6 0;
}

.lst-kix_list_1-1 > li {
  counter-increment: lst-ctn-kix_list_1-1;
}

ol.lst-kix_list_1-3.start {
  counter-reset: lst-ctn-kix_list_1-3 0;
}

ol.lst-kix_list_1-2.start {
  counter-reset: lst-ctn-kix_list_1-2 0;
}

ol.lst-kix_list_1-8.start {
  counter-reset: lst-ctn-kix_list_1-8 0;
}

.lst-kix_list_1-0 > li:before {
  content: "" counter(lst-ctn-kix_list_1-0, lower-latin) ") ";
}

ol.lst-kix_list_1-5.start {
  counter-reset: lst-ctn-kix_list_1-5 0;
}

ol.lst-kix_list_1-7 {
  list-style-type: none;
}

.lst-kix_list_1-1 > li:before {
  content: "" counter(lst-ctn-kix_list_1-1, lower-latin) ". ";
}

.lst-kix_list_1-2 > li:before {
  content: "" counter(lst-ctn-kix_list_1-2, lower-roman) ". ";
}

.lst-kix_list_1-7 > li {
  counter-increment: lst-ctn-kix_list_1-7;
}

ol.lst-kix_list_1-8 {
  list-style-type: none;
}

.lst-kix_list_1-3 > li:before {
  content: "" counter(lst-ctn-kix_list_1-3, decimal) ". ";
}

.lst-kix_list_1-4 > li:before {
  content: "" counter(lst-ctn-kix_list_1-4, lower-latin) ". ";
}

ol.lst-kix_list_1-0.start {
  counter-reset: lst-ctn-kix_list_1-0 0;
}

.lst-kix_list_1-0 > li {
  counter-increment: lst-ctn-kix_list_1-0;
}

.lst-kix_list_1-6 > li {
  counter-increment: lst-ctn-kix_list_1-6;
}

.lst-kix_list_1-7 > li:before {
  content: "" counter(lst-ctn-kix_list_1-7, lower-latin) ". ";
}

.lst-kix_list_1-3 > li {
  counter-increment: lst-ctn-kix_list_1-3;
}

.lst-kix_list_1-5 > li:before {
  content: "" counter(lst-ctn-kix_list_1-5, lower-roman) ". ";
}

.lst-kix_list_1-6 > li:before {
  content: "" counter(lst-ctn-kix_list_1-6, decimal) ". ";
}

li.li-bullet-0:before {
  margin-left: -28.4pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 28.4pt;
}

ol.lst-kix_list_1-7.start {
  counter-reset: lst-ctn-kix_list_1-7 0;
}

.lst-kix_list_1-2 > li {
  counter-increment: lst-ctn-kix_list_1-2;
}

.lst-kix_list_1-5 > li {
  counter-increment: lst-ctn-kix_list_1-5;
}

.lst-kix_list_1-8 > li {
  counter-increment: lst-ctn-kix_list_1-8;
}

ol.lst-kix_list_1-4.start {
  counter-reset: lst-ctn-kix_list_1-4 0;
}

.lst-kix_list_1-8 > li:before {
  content: "" counter(lst-ctn-kix_list_1-8, lower-roman) ". ";
}

ol.lst-kix_list_1-1.start {
  counter-reset: lst-ctn-kix_list_1-1 0;
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c22 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Montserrat";
  font-style: normal;
}

.c11 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal;
}

.c4 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Montserrat";
  font-style: normal;
}

.c1 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Montserrat";
  font-style: normal;
}

.c9 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.4166666666666667;
  text-align: left;
}

.c20 {
  font-size: 8pt;
  font-family: "Montserrat";
  color: #424242;
  font-weight: 700;
}

.c6 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.4166666666666667;
  text-align: center;
}

.c0 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.4166666666666667;
  text-align: justify;
}

.c18 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-style: italic;
}

.c16 {
  -webkit-text-decoration-skip: none;
  color: #0000ff;
  text-decoration: underline;
  text-decoration-skip-ink: none;
}

.c21 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}

.c3 {
  font-size: 12pt;
  font-family: "Montserrat";
  font-weight: 700;
}

.c5 {
  font-size: 12pt;
  font-family: "Montserrat";
  font-weight: 400;
}

.c13 {
  background-color: #ffffff;
}

.c10 {
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
}

.c2 {
  margin-left: 18pt;
  padding-left: 10.4pt;
}

.c23 {
  vertical-align: baseline;
  font-style: normal;
}

.c14 {
  color: inherit;
  text-decoration: inherit;
}

.c15 {
  padding: 0;
  margin: 0;
}

.c24 {
  margin-left: 9.8pt;
  text-indent: 9.8pt;
}

.c17 {
  text-indent: -0.2pt;
}

.c7 {
  height: 11pt;
}

.c19 {
  font-style: italic;
}

.c8 {
  margin-right: 5.9pt;
}

.c12 {
  text-indent: -0.1pt;
}

.title {
  padding-top: 12.7pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 0pt;
  font-family: "Arial";
  line-height: 1;
  text-align: center;
}

.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  font-family: "Georgia";
  line-height: 1;
  page-break-after: avoid;
  font-style: italic;
  text-align: left;
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial";
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial";
}

h1 {
  padding-top: 0pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 0pt;
  font-family: "Arial";
  line-height: 1;
  text-align: center;
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}

h3 {
  padding-top: 14pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}

h4 {
  padding-top: 12pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}

h5 {
  padding-top: 11pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}

h6 {
  padding-top: 10pt;
  color: #000000;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1;
  page-break-after: avoid;
  text-align: left;
}
</style>
